export const checkSizeLimit = (
  currentSize: number,
  sizeLimit: number
): boolean => currentSize / 1024 / 1024 > sizeLimit;
